module.exports = __webpack_public_path__ + "static/media/BestBuyAwards.97af3347.png";